/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Agent session and turn identity, independent of provider naming.
 */
export type HookIngestSession = {
  /**
   * Current working directory when the event fired.
   */
  cwd?: string | undefined;
  /**
   * Stable conversation or session identifier.
   */
  id?: string | undefined;
  /**
   * Model identifier reported by the local agent.
   */
  model?: string | undefined;
  /**
   * Generation, request, or turn identifier.
   */
  turnId?: string | undefined;
};

/** @internal */
export type HookIngestSession$Outbound = {
  cwd?: string | undefined;
  id?: string | undefined;
  model?: string | undefined;
  turn_id?: string | undefined;
};

/** @internal */
export const HookIngestSession$outboundSchema: z.ZodMiniType<
  HookIngestSession$Outbound,
  HookIngestSession
> = z.pipe(
  z.object({
    cwd: z.optional(z.string()),
    id: z.optional(z.string()),
    model: z.optional(z.string()),
    turnId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      turnId: "turn_id",
    });
  }),
);

export function hookIngestSessionToJSON(
  hookIngestSession: HookIngestSession,
): string {
  return JSON.stringify(
    HookIngestSession$outboundSchema.parse(hookIngestSession),
  );
}
